import React from 'react';
import TablePage from '../../../../../components/pages/TablePage';
import moment from 'moment';
export default () => {
    const columns = [
        {
            selector: (row) => row?.npwp,
            name: "NPWP",
            id: 'npwp',
            width: "200px"
        },
        {
            selector: (row) => row?.name,
            name: "Name",
            id: 'name'
        },
        {
            selector: (row) => row?.country,
            name: "Country Code",
            id: 'country'
        },
        {
            selector: (row) => row?.address,
            name: "Address 1",
            id: 'address'
        },
        {
            selector: (row) => row?.address2,
            name: "Address 2",
            id: 'address2'
        },
        {
            selector: (row) => row?.address3,
            name: "Address 3",
            id: 'address3'
        },
        {
            selector: (row) => (row?.createdAt && moment(row.createdAt).format('DD-MMM-YYYY')) || '-',
            name: "Created",
            id: 'CreatedAt'
        },
    ]
    return (
        <TablePage
            title={"Master Notify"}
            url="api/v1/notify"
            actionPosition={'first'}
            createPath="/master/notify/create"
            editPath={"/master/notify/edit"}
            columns={columns}
        />
    )
}
